<template>
  <app-page :head="data.head" :body="data.body" :subpages="data.subpages" />
</template>

<script setup>
definePageMeta({
  middleware: [
    function (to) {
      // get last element of the path
      if (to.fullPath.split("/").pop() === "projects-and-stories") {
        return navigateTo(
          `/${to.params.country}/${to.params.locale}/projects-and-stories/projects`
        );
      }
    },
  ],
});

const { params } = useRoute();

const { data } = await useFetch(`/api/page_stories?lng=${params.locale}`);
</script>
